import { combineReducers } from 'redux';
import settings from './settings/reducer';
import menu from './menu/reducer';
// import authUser from './auth/reducer';
import estadoPagina from './status/reducer';
import statePage from './v2/status/reducer';

const appReducer = combineReducers({
  // authUser,
  settings,
  menu,
  estadoPagina,
  statePage,
});

const reducers = (state, action) => {
  // console.log(state, action)
  return appReducer(state, action);
};

export default reducers;
